import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface ConfigGeraisModel {
    qtdeSetores: number;
    qtdeProcessos: number;
    visualizarTpPedido: number[];
    habilitarAudioPedidoNovo: boolean;
    intervaloAudioPedidoNovoMs: number;
}

interface ConfigGeraisStore {
    config: ConfigGeraisModel;
    setConfig: (config: Partial<ConfigGeraisModel>) => void;
}

export const useConfigGeraisStore = create<ConfigGeraisStore>()(
    persist(
        (set) => ({
            config: {
                qtdeSetores: 1,
                qtdeProcessos: 2,
                visualizarTpPedido: [0, 1],
                habilitarAudioPedidoNovo: true,
                intervaloAudioPedidoNovoMs: 15000
            },
            setConfig: (newConfig) => set((state) => ({
                config: {
                    ...state.config,
                    ...newConfig
                }
            }))
        }),
        {
            name: 'config-gerais-storage',
        }
    )
)
